import { useTranslation } from 'react-i18next';

import { AddIcon } from '@treams/treams-icons';
import { Button, Jumbo } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

import OutgoingConversationsList from './OutgoingConversationsList';
import ViewerConversationTabs from './ViewerConversationTabs';
import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';

export default function ViewerOutgoingConversations() {
	const { t } = useTranslation();
	const userID = useAuthenticatedUser().id;
	const isAdhocEnabled = useFeature('2021.evaluations.adhoc');

	const query = graphql.useOutgoingEvaluationSubmissionsQuery({
		variables: { userID, isArchived: false, last: 5 },
	});

	const [fetchArchived, archivedQuery] = graphql.useOutgoingEvaluationSubmissionsLazyQuery({
		variables: { userID, isArchived: true, last: 5 },
	});

	return (
		<>
			<Jumbo
				title={t('conversations.index.title')}
				description={t('conversations.index.description')}
				button={
					isAdhocEnabled && (
						<Button
							icon={<AddIcon />}
							title={t('conversations.index.new')}
							link="/conversations/request-from-moment"
						/>
					)
				}
				footer={<ViewerConversationTabs />}
			/>

			<OutgoingConversationsList
				fetchArchived={fetchArchived}
				archivedQuery={archivedQuery}
				query={query}
			/>
		</>
	);
}
